import { SetBtnObstActive } from './ObstructionControl';
import { AddStep } from "./StepControl";
import { GetAlt } from "./TerrainControl";
import { useViewerStore } from "../../../../../store/store";
import { SHADE_CALCULATIONS, siteCalculationState } from "../../../../../services/siteCalculationState";
import { getPathnameIncludes } from "../../../../../helpers/getPathname";
import { UpdatePlaneRoof } from "./PlaneRoofControls";
import { GetRadVal } from "./Common";
import { Box3, Box3Helper, Raycaster, Vector3 } from "three";
import { addSelectedTree, removeSelectedTree, toggleSelectedTree } from "../../../../../helpers/storeHelpers";
import { Viewer } from '../Viewer-Factory/Viewer';


//Move Mesh Functions
export function TransDown(e: any, self: Viewer) {
    self.controls.enabled = false;
    self.flagTransChange = true;
    self.selTreeArr.forEach(tree => {
        tree.oriPos = { ...tree.position }
    });
    self.transform.object.oriPos = { ...self.transform.object.position };
}

export function TransUp(e: any, self: Viewer) {
    const { selectType, selTreeArr, mapCustom }: any = self;
    if (selectType === 'tree') {
        CheckIsTreeCollidingWithRoof(selTreeArr);
        const selObj: string[] = [], oriPosArr: any = [], newPosArr: any = [];
        selTreeArr.forEach((group: any) => {
            selObj.push(group.obstId);
            oriPosArr.push({ ...group.oriPos });
            newPosArr.push({ ...group.position });
            const newPos = group.position;
            group.children[2].worldPos = { x: newPos.x, y: newPos.y, z: newPos.z };
        });
        useViewerStore.setState({ hasTreeMoved: true });
        AddStep(self, 'treeMove', selObj, oriPosArr, newPosArr);
    } else if (selectType === 'roof') {
        const { position }: any = mapCustom;
        const newPosition = { x: position.x, y: position.y, z: position.z };
        AddStep(self, 'mapMove', [], mapCustom.oriPos, newPosition);
    }
    if (selectType === 'surface') {
        const worldPosition = new Vector3();
        self.transform.object.getWorldPosition(worldPosition);
        const face = self.roofs[0].faces.find((face: any) => face.roofFaceId === self.transform.object.roofFaceId);
        const scale = face ? face.scl : { x: 6.096, y: 6.096 };
        const azimuth = face ? face.oriAng.azimuth : 0;

        // Calculate the offset from the center to the corner, considering azimuth
        const halfWidth = scale.x / 2;
        const halfDepth = scale.y / 2;
        const azimuthRad = GetRadVal(azimuth); // Convert azimuth to radians

        const cosAzi = Math.cos(azimuthRad);
        const sinAzi = Math.sin(azimuthRad);

        const offsetX = -halfWidth;
        const offsetZ = -halfDepth;

        const rotOffsetX = offsetX * cosAzi - offsetZ * sinAzi;
        const rotOffsetZ = offsetX * sinAzi + offsetZ * cosAzi;

        const newPositionX = worldPosition.x + rotOffsetX;
        const newPositionZ = worldPosition.z + rotOffsetZ;

        UpdatePlaneRoof(self, "pos", { x: newPositionX, y: newPositionZ });
        self.transform.detach();
        self.selFlatRoof = null;
    }

    self.controls.enabled = true;
    self.flagTransChange = false;
}

export function CheckIsTreeCollidingWithRoof(selTreeArr: any[]) {
    //Display only for Sales Ops and RSA
    const userRole = sessionStorage.getItem("userRole");


    if (userRole && userRole !== "Sales Ops" && userRole !== "RSA" && userRole !== "Admin") return;


    const flagRoof = selTreeArr.find(tree => {
        let isCollidingWithRoof = false;


        const treePos = tree.position;
        const sceneViewer = useViewerStore.getState().sceneViewer;
        const treeMesh = tree.children[0];

        const ray = new Raycaster();
        ray.camera = sceneViewer?.camera;

        ray.set(new Vector3(treePos.x, treePos.y, treePos.z), new Vector3(0, 1, 0));

        const intersects = ray.intersectObjects(sceneViewer?.roofMeshArr);
        if (intersects.length > 0) {
            isCollidingWithRoof = true
        }

        treeMesh.userData.isCollidingWithRoof = isCollidingWithRoof;

        return isCollidingWithRoof;
    });
    if (flagRoof) {
        const sceneViewer = useViewerStore.getState().sceneViewer;
        sceneViewer?.viewerAlert({
            show: true,
            title: "Warning",
            message: "Tree Position : Tree is either colliding with the roof or is too close to the roof edges",
            messageType: "warning",
            isModal: false,
            isCloseAfterDisplay: true,
            autoCloseSeconds: 4000
        });
    }
}

export function TransChange(e: any, self: Viewer) {
    const { transform, treeGroup, terrainArr, buildingAlt } = self,
        transObj = transform.object;
    if (!transObj) return;

    const { meshType } = transObj;

    if (meshType === 'tree') {
        const { oriPos, position } = transObj,
            deltaDis = { x: position.x - oriPos.x, z: position.z - oriPos.z };

        treeGroup.children.forEach((group: any) => {
            if (!group.select) return;
            const newPos = { x: group.oriPos.x + deltaDis.x, z: group.oriPos.z + deltaDis.z };
            const deltaBuildingH = ( buildingAlt?.low ?? 0) + 0.2;
            const posYOfTree = GetAlt(terrainArr, newPos, deltaBuildingH);
            group.position.set(newPos.x, posYOfTree, newPos.z);
        });
        siteCalculationState.needsUpdate(SHADE_CALCULATIONS);
    }
}

export function SetupInputValue(idKey: string, value: number, intType?: boolean) {
    const valueFT = Math.round(value * 32.8084) / 10;
    const inputEle: any = document.getElementById('input' + idKey),
        rangeEle: any = document.getElementById('range' + idKey);
    if (inputEle) {
        inputEle.value = intType ? value : valueFT;
    }

    const roofUnitOfMeasure = useViewerStore.getState().roofUnitOfMeasure;

    if (rangeEle) {

        if (idKey.includes("Wall")) {

            if (roofUnitOfMeasure === 'ft') {
                rangeEle.value = valueFT
                inputEle.value = valueFT
            } else if (roofUnitOfMeasure === 'in') {
                rangeEle.value = Math.round(value * 39.37);
                inputEle.value = Math.round(value * 39.37);
            } else {
                rangeEle.value = value.toFixed(2);
            }

            return

        }

        rangeEle.value = intType ? value : valueFT;
    }
}

export function SetupTreeGroup(self: Viewer, treeId: string, isRightClick = false) {
    const treeGroup: any = self.treeGroup.children.find((item: any) => item.obstId === treeId);

    if (treeGroup) {
        if (getPathnameIncludes("tree") && !isRightClick) {
            treeGroup.select = !treeGroup.select;
            toggleSelectedTree(treeGroup);
        } else if (isRightClick) {
            treeGroup.select = true
            addSelectedTree(treeGroup);
        }
    }

    SetTreeTransArr(self);
}


export function SetupInputTreeUI(treeTransMesh: any, treeGroup: any) {
    const cMesh = treeGroup.children[0], { crownScl, scale } = cMesh,
        cScl = { x: scale.x / crownScl.x, y: scale.y / crownScl.y, z: scale.z / crownScl.z };
    const tScl = treeGroup.children[1].scale, { position } = treeTransMesh;
    const treeSize = {
        TreeTotalHeight: cScl.y + tScl.y / 1.3,
        TreeCrownRadius: cScl.x,
        TreeCrownHeight: cScl.y,
        TreeTrunkRadius: tScl.x * 2,
        TreePosX: position.x,
        TreePosY: position.z
    };
    (Object.keys(treeSize) as (keyof typeof treeSize)[]).forEach(key => {
        SetupInputValue(key, treeSize[key]);
    });
    SetDelIconUI('tree', treeGroup.delStatus);
}

export function SelectAllTrees(self: Viewer) {
    if (self.pushMode || self.moveMode) return;
    var checkAll = true;
    self.treeGroup.children.forEach((tree: any) => {
        if (!tree.select) checkAll = false;
    });
    self.treeGroup.children.forEach((tree: any) => {
        tree.select = !checkAll;
        if (tree.select) {
            addSelectedTree(tree);
        } else {
            removeSelectedTree(tree);
        }
    });
    SetTreeTransArr(self);
}

export function SetTreeTransArr(self: Viewer, clear?: boolean) {
    self.transform.detach();
    self.selTreeArr = [];
    self.treeTransMesh!.visible = false;
    const minPos = { x: Infinity, z: Infinity }, maxPos = { x: -Infinity, z: -Infinity };
    var checkAll = true, checkSelect = false;
    self.treeGroup.children.forEach((group: any) => {
        const { x, z } = group.position;
        if (clear) {
            group.select = false;
            removeSelectedTree(group);
        }
        if (group.select) {
            group.oriPos = { x, z };
            self.selTreeArr.push(group);
            if (x < minPos.x) minPos.x = x;
            if (x > maxPos.x) maxPos.x = x;
            if (z < minPos.z) minPos.z = z;
            if (z > maxPos.z) maxPos.z = z;
            checkSelect = true;
        } else {
            checkAll = false;
        }

        if (group.select) {
            group.children[0].material.emissive.setHex(0x000ff);
        } else {
            group.children[0].material.emissive.setHex(0x000000);
        }

        // group.children[2].visible = group.select;
    });
    self.transform.detach();
    if (self.selTreeArr.length) {
        const centerX = (minPos.x + maxPos.x) / 2, centerZ = (minPos.z + maxPos.z) / 2;
        if (self.treeTransMesh) {
            self.treeTransMesh.visible = true;
            self.treeTransMesh.position.set(centerX, 0, centerZ);
            (self.treeTransMesh as any).oriPos = { x: centerX, z: centerZ };
        }
        if (self.moveMode) self.transform.attach(self.treeTransMesh);
        SetupInputTreeUI(self.treeTransMesh, self.selTreeArr[0]);
    } else if (self.virTree?.visible) {
        SetupInputTreeUI(self.treeTransMesh, self.virTree);
    }
    const btnSelectAllTrees = document.getElementsByClassName('btnSelectAllTrees')[0];
    // const btnTreeMove = document.getElementsByClassName('btnTreeMove')[0];
    // if (btnSelectAllTrees) btnSelectAllTrees.textContent = checkAll ? 'Unselect All' : 'Select All';
    // if (btnTreeMove) {
    //     if (checkSelect) btnTreeMove.classList.remove('disabled');
    //     else btnTreeMove.classList.add('disabled');
    // }
    const btnTreeCopy = document.getElementsByClassName('btnTreeCopy')[0],
        btnTreeDel = document.getElementsByClassName('btnTreeDel')[0];
    if (btnTreeCopy && btnTreeDel) {
        if (checkSelect) {
            btnTreeCopy.classList.remove('disabled');
            btnTreeDel.classList.remove('disabled');
        } else {
            btnTreeCopy.classList.add('disabled');
            btnTreeDel.classList.add('disabled');
        }
    }
}

function GetObstMeshArr(group: any, selId?: string) {
    const obstMeshArr: any[] = [], selMeshArr: any[] = [];
    group.children.forEach((obst: any) => {
        const obstMesh = obst.children[0].children[0].children[0];
        if (selId && obstMesh.obstId === selId) {
            obstMesh.select = !obstMesh.select;
        }
        if (obstMesh.select) selMeshArr.push(obstMesh);
        obstMeshArr.push(obstMesh);
    });
    return selMeshArr.length ? selMeshArr : obstMeshArr;
}

export function SetupObstUI(self: Viewer, newObstId?: string) {
    const { obstGroup, virObs, tabInfo }: any = self;
    if (tabInfo === 'Obstruction Properties') self.obstId = newObstId || null;
    else if (tabInfo === 'Obstruction Style') self.obstMeshArr = GetObstMeshArr(obstGroup, newObstId);
    var selObstMesh, selPos = { x: 0, y: 0 };
    // const btnObstMove = document.getElementsByClassName('btnObstMove')[0];
    obstGroup.children.forEach((group: any) => {
        const inGroup = group.children[0].children[0], obstMesh = inGroup.children[0], obstFrame = inGroup.children[1];
        if (tabInfo === 'Obstruction Properties') {
            obstFrame.visible = (self.obstId && group.obstId === self.obstId) ? true : false;
            if (self.obstId && group.obstId === self.obstId) {
                selObstMesh = obstMesh;
                selPos = group.position;
                SetupSwitchObstRot(obstMesh.verFloor);
                SetDelIconUI('obst', obstMesh.delStatus);
            }
        } else if (tabInfo === 'Obstruction Style') obstFrame.visible = obstMesh.select;
    });
    if (virObs.visible) {
        selObstMesh = virObs.children[0].children[0].children[0];
    }
    if (selObstMesh) {
        SetBtnObstActive(selObstMesh.shapeNum);
        // if (btnObstMove) btnObstMove.classList.remove('disabled');
    } else {
        SetupSwitchObstRot(false);
        // if (btnObstMove) btnObstMove.classList.add('disabled');
    }

    useViewerStore.setState({ selectedObstruction: selObstMesh })
    SetupInputObstUI(selObstMesh, selPos);

    const btnObstCopy = document.getElementsByClassName('btnObstCopy')[0],
        btnObstDel = document.getElementsByClassName('btnObstDel')[0];
    if (btnObstCopy && btnObstDel) {
        if (selObstMesh) {
            btnObstCopy.classList.remove('disabled');
            btnObstDel.classList.remove('disabled');
        } else {
            btnObstCopy.classList.add('disabled');
            btnObstDel.classList.add('disabled');
        }
    }
}

export function SetupInputObstUI(selObstMesh: any, pos: { x: number, y: number }) {
    ['Height', 'Width', 'Length', 'Sides', 'Diameter', 'Radius', 'PosX', 'PosY'].forEach(label => {
        const key = label.toLocaleLowerCase();
        var val = key === 'sides' ? 3 : 0.3;
        if (key.includes('pos')) val = 0;
        if (selObstMesh) {
            val = selObstMesh[key];
            if (key === 'radius') val /= 2;
            else if (key === 'posx') val = pos.x;
            else if (key === 'posy') val = pos.y;
        }
        SetupInputValue('Obst' + label, val, label === 'Sides');
    });
}

export function SetupSwitchObstRot(verFloor: boolean) {
    const switchObstVer = document.getElementById('switchObstVer');
    if (!switchObstVer) return;
    if (verFloor) switchObstVer.classList.add('toggled');
    else switchObstVer.classList.remove('toggled');
}

export function SetDelIconUI(key: string, delStatus: boolean) {
    const delBtn = document.getElementsByClassName('btn' + key + 'Del')[0];
    if (!delBtn) return;
    if (delStatus) delBtn.classList.add('active');
    else delBtn.classList.remove('active');
}
